module.exports = __webpack_public_path__ + "img/logo.4d15b004.png";